export const searchOpenEventName = "tmd:search:open";

/**
 * Dispatches the shared search-open event to currently registered window listeners.
 *
 * Preconditions: A browser window is available.
 * Postconditions: Synchronous dispatch has returned; this does not guarantee a mounted or open
 * search interface. React listeners request their updates for subsequent renders.
 */
const openSearch = () => {
    window.dispatchEvent(new Event(searchOpenEventName));
};

export default openSearch;
